<template>
    <div class="part5 part">
        <div class="top" :class="{animate1: isAnimate1}">
            <div class="title" :class="{animate1: isAnimate1}">产品亮点</div> 
        </div>
        <p class="center" :class="{animate1: isAnimate1}">
            提供移动化、智能化、数据化、可视化的产品与服务
        </p>
        <div class="bottom">
          <el-row :gutter="10">
            <el-col :span="12">
              <div class="left left1 leftPic pic">
                <img :class="{animate1: isAnimate1}" src="../../static/images/left1.png" alt="">
              </div>
              <div class="left left2 leftText text">
                <div class="textBox" :class="{animate2: isAnimate2}">
                    <h1>承上启下的联络员，让沟通更顺畅</h1>
                    <p class="line"></p>
                    <p class="describe">优化角色分工和管理机制，为基层网评队伍设立“联络员”，完成自身任务的同时，协助监督网评小组工作进度。</p>
                </div>
              </div>
              <div class="left left3 leftPic pic">
                <img :class="{animate3: isAnimate3}" src="../../static/images/left2.png" alt="">
              </div>
              <div class="left left4 leftText text">
                <div :class="{animate4: isAnimate4}" class="textBox">
                    <h1>网评机器人，网评任务一呼百应</h1>
                    <p class="line"></p>
                    <p class="describe">
                    提供真实的主流站点账号，组成“智能网军”，满足传播、引导过程中的各类需求，极大缓解人力不足的窘境。
                    </p>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="right right1 rightText text">
                <div class="textBox" :class="{animate1: isAnimate1}">
                    <h1>多端联动，移动办公</h1>
                    <p class="line"></p>
                    <p class="describe">
                    APP与微信公众号、PC等多端联动，信息实时同步，满足日常工作和突发事件下各种应用场景，提升工作效率。
                    </p>
                </div>
              </div>
              <div class="right right2 rightPic pic">
                <img :class="{animate2: isAnimate2}" src="../../static/images/right1.png" alt="">
              </div>
              <div class="right right3 rightText text">
                <div class="textBox" :class="{animate3: isAnimate3}">
                    <h1>智能化任务处理，高效便捷</h1>
                    <p class="line"></p>
                    <p class="describe">
                    强大的社交媒体账号互通机制，省去二次登录的繁琐，系统内即可完成微信、微博等平台网评任务，并自动截图上传。
                    </p>
                </div>
              </div>
              <div class="right right4 rightPic pic">
                <img :class="{animate4: isAnimate4}" src="../../static/images/right2.png" alt="">
              </div>
            </el-col>
          </el-row>
        </div>
    </div>
</template>
<script>
export default {
    name :"Partfive",
    data(){
        return{
          isAnimate1:false,
          isAnimate2:false,
          isAnimate3:false,
          isAnimate4:false
        }
    },
    mounted:function(){
      document.addEventListener("scroll",this.actionAnima);
    },
    methods:{
      actionAnima:function(){
        let _self = this;
        const bodyH = document.body.scrollTop || document.documentElement.scrollTop;
        if(bodyH >= 1700){
          _self.isAnimate1 = true;
        }
        if(bodyH >= 2200){
          _self.isAnimate2 = true;
        }
        if(bodyH >= 2600){
          _self.isAnimate3 = true;
        }
        if(bodyH >= 3000){
          _self.isAnimate4 = true;
        }
      }
    }
}
</script>
<style scoped>
  .part5 .top{
    height: 132px;
    line-height: 132px;
    width: 540px;
    margin: 100px auto 10px auto;
    background: url(../../static/images/function.png) no-repeat;
    background-size: 100% auto;
    background-position: center top;
    text-align: center;
    font-size: 40px;
  }
  .part5 .top.animate1{
    animation: topBgDown 0.5s linear forwards;
  }
	.part5 .top .title{
		position: relative;
		opacity: 0;
	}
  .part5 .top .title.animate1{
    animation: topUp 0.6s linear forwards;
    animation-delay: 0.3s;
  }
  .part5 p.center{
    margin: 0 auto;
    text-align: center;
    font-size: 18px;
    height: 50px;
    color: #666;
    opacity: 0;
  }
  .part5 p.center.animate1{
    animation: topUp 0.6s linear forwards;
		animation-delay:0.6s;
  }
  .part5 .bottom{
    width: 1200px;
    margin: 50px auto;
    /* border: 1px solid red; */
  }
  .part5 .bottom img{
    width: 540px;
    height: 100%;
		position: relative;
  }
  .part5 .bottom .pic{
    height: 390px;
    text-align: center;
  }
  .part5 .bottom .text{
    height: 390px;
  }
  .part5 .bottom .textBox{
    width: 450px;
    margin: 100px auto;
    text-align: left;
    /* border: 1px solid #333; */
		position: relative;
  }
  .part5 .bottom .textBox h1{
    font-size: 30px;
  }
  .part5 .bottom .left .textBox{
    margin-left: 20px;
  }
  .part5 .bottom .textBox p.line{
    height: 5px;
    width: 28px;
    margin: 20px 0;
    background: #309c81;
  }
  .part5 .bottom .textBox p.describe{
    color: #666;
  }
	.part5 .bottom .right1 .textBox{
		opacity: 0;
	}
  .part5 .bottom .right1 .textBox.animate1{
    animation: bottomTextLeft .5s linear forwards;
    animation-delay: 0.6s;
  }
	.part5 .bottom .right3 .textBox{
		opacity: 0;
	}
  .part5 .bottom .right3 .textBox.animate3{
    animation: bottomTextLeft .5s linear forwards;
  }
	.part5 .bottom .left2 .textBox{
		opacity: 0;
	}
  .part5 .bottom .left2 .textBox.animate2{
		animation: bottomTextRight .5s linear forwards;
	}
	.part5 .bottom .left4 .textBox{
		opacity: 0;
	}
  .part5 .bottom .left4 .textBox.animate4{
		animation: bottomTextRight .5s linear forwards;
	}
	.part5 .bottom .left1 img{
		opacity: 0;
	}
  .part5 .bottom .left1 img.animate1{
		animation: bottomTextRight .5s linear forwards;
    animation-delay: 0.3s;
	}
	.part5 .bottom .left3 img{
		opacity: 0;
	}
  .part5 .bottom .left3 img.animate3{
    animation: bottomTextRight .5s linear forwards;
  }
	.part5 .bottom .right2 img{
		opacity: 0;
	}
  .part5 .bottom .right2 img.animate2{
    animation: bottomTextLeft .5s linear forwards;
    animation-delay: 0.3s;
  }
	.part5 .bottom .right4 img{
		opacity: 0;
	}
  .part5 .bottom .right4 img.animate4{
    animation: bottomTextLeft .5s linear forwards;
  }
	@keyframes topUp{
		from{
				top: 15px;
				opacity: 0;
		}to{
				top: 0px;
				opacity: 1;
		}
  }
	@keyframes topBgDown{
		from{
			background-position: center top;
		}to{
			background-position: center center;
		}
  }
	@keyframes bottomTextLeft{
		from{
				left: 15px;
				opacity: 0;
		}to{
				left: 0px;
				opacity: 1;
		}
  }
	@keyframes bottomTextRight{
		from{
				left: -15px;
				opacity: 0;
		}to{
				left: 0px;
				opacity: 1;
		}
  }
  @media (max-width: 1439px){
    .part5 p.center{
      width: 800px;
    }
    .part5 .bottom{
      width: 1000px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Partfive.vue